export default "__VITE_ASSET__CKVKOeUX__"